<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title ">Daftar Invoice Paid <small>(Invoice Sudah Dibayar)</small> Bulan {{tanggal_tampil}}</h3>
                <div class="card-tools">
                  <!--button type="button" class="btn btn-sm btn-success" @click="false">
                      <i class="fa fa-check-square"></i>
                     &nbsp; PAID
                  </button>
                  <button type="button" class="btn btn-sm btn-danger" @click="false">
                      <i class="fa fa-credit-card"></i>
                     &nbsp; CREATE VA
                  </button>
                  <button type="button" class="btn btn-sm btn-warning" @click="false">
                      <i class="fa fa-print"></i>
                     &nbsp; Print Invoice
                  </button-->
                  <v-dialog
                    ref="dialog"
                    v-model="modaltgl"
                    :return-value.sync="tanggal_query"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field style="margin-top:0px;padding-top:0px"
                        v-model="tanggal_query"
                       
                        label=""
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="tanggal_query"
                      type="month"
                      scrollable
                      min="2022-08"
                      :max="dateMax"
                      
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="modaltgl = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="ubahTanggalTampil($refs)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>
              <!-- /.card-header -->
              <v-app>
                <v-content>
                  <div class="card-body ">
                    <ul class="nav nav-tabs" id="custom-content-above-tab" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" id="custom-content-above-home-tab" data-toggle="pill" href="#custom-content-above-home" role="tab" aria-controls="custom-content-above-home" aria-selected="true"><i class="fa fa-user-alt"></i>  PPPOE</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="custom-content-above-profile-tab" data-toggle="pill"  href="#custom-content-above-profile" role="tab" aria-controls="custom-content-above-profile" aria-selected="false"><i class="fa fa-users"></i> CORPORATE</a>
                      </li>
                    </ul>
                    <div class="tab-custom-content">
                      
                    </div>
                    <div class="tab-content" id="custom-content-above-tabContent">
                      <div class="tab-pane fade show active" id="custom-content-above-home" role="tabpanel" aria-labelledby="custom-content-above-home-tab">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="small-box bg-primary">
                                <div class="inner">
                                    <h3>{{parseInt(jlh_data_pppoe)}}</h3>
                                    <small>Jumlah Invoice Paid</small>
                                    <!--p>dari {{parseInt(jlh_invoice)}} Unpaid Bulan Ini</p-->
                                </div>
                                <div class="icon">
                                    <i class="fas fa-users"></i>
                                </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="small-box bg-primary">
                                <div class="inner">
                                    <h3>{{parseInt(ttl_data_pppoe) | toCurrency}}</h3>
                                    <small>Total Rp Invoice Paid</small>
                                    <!--p>Unpaid Bulan Ini</p-->
                                </div>
                                <div class="icon">
                                    <i class="fas fa-money-bill"></i>
                                </div>
                            </div>
                          </div>
                        </div>
                        <v-row class="mb-1">
                          <v-col :md="4">
                            <v-select
                              v-model="filter_pppoe"
                              :items="filter_plg"
                              item-text="text"
                              item-value="id"
                              label="Pilih Filter"
                              persistent-hint
                              return-object
                              single-line
                            ></v-select>
                          </v-col>
                          <v-col :md="4" :offset-md="4">
                            <v-text-field
                              v-model="cari_dt_plg"
                              append-icon="mdi-magnify"
                              label="Pencarian"
                              single-line
                              hide-details
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-data-table
                          @update:group-desc="tableGrouping"
                          :headers="headers"
                          :footer-props="{ itemsPerPageOptions: [10,25,50,100,-1]}"
                          :items="datas"
                          :items-per-page="25"
                          item-key="id"
                          sort-by="no"
                          class="elevation-1 "
                          show-group-by
                          :search="cari_dt_plg">
                          <template v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
                            <td :colspan="headers.length-1">
                              <v-btn @click="toggle" x-small icon :ref="group">
                                  <v-icon v-if="isOpen">mdi-minus</v-icon>
                                  <v-icon v-else>mdi-plus</v-icon>
                              </v-btn>
                              <span class="mx-3"> Nama Pelanggan : <span class="font-weight-bold"> {{ group }}</span></span>
                              <!--a href="#" @click="editModal(item,'pelanggan')" title="Edit Data Pelanggan">
                                <i class="fa fa-user-edit text-blue"></i>
                              </a-->
                            </td>
                            <td>
                              <v-btn @click="remove" x-small icon class="">
                                  <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </td>
                          </template>
                          <!--template v-slot:item.checkbox="{ item }">
                            <v-container
                              class="px-0"
                              fluid
                            >
                              <v-checkbox
                              ></v-checkbox>
                            </v-container>
                          </template-->
                          <template v-slot:item.no="{ item }">
                            {{ item.no | zerofill }}
                          </template>
                          <template v-slot:item.total_kontrak="{ item }">
                            {{ parseInt(item.harga_paket) + parseInt(item.ppn_rp) - parseInt(item.diskon_rp) | toCurrency }}
                          </template>
                          <template v-slot:item.total_bayar="{ item }">
                            {{ item.total_bayar | toCurrency }}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            
                            <div class="tanpawrap">
                              <!--a href="#" class="mr-1" title="Lihat Detail Pelanggan">
                                <i class="fa fa-info-circle"></i>
                              </a-->
                              <a href="#" class="mr-1" @click="printInvoice(item)" title="Lihat Invoice">
                                <i class="fa fa-file"></i>
                              </a>
                              /
                              <a href="#" class="ml-1" @click="bukaModal(item)" title="Edit Data">
                                <i class="fa fa-edit"></i>
                              </a>
                            </div>
                            
                          </template>
                          <template v-slot:no-data>
                            <h4>Data Tidak Ditemukan</h4>
                          </template>
                        </v-data-table>
                      </div>
                      <div class="tab-pane fade" id="custom-content-above-profile" role="tabpanel" aria-labelledby="custom-content-above-profile-tab">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="small-box bg-primary">
                                <div class="inner">
                                    <h3>{{parseInt(jlh_data_corpo)}}</h3>
                                    <small>Jumlah Invoice Paid</small>
                                    <!--p>dari {{parseInt(jlh_invoice)}} Unpaid Bulan Ini</p-->
                                </div>
                                <div class="icon">
                                    <i class="fas fa-users"></i>
                                </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="small-box bg-primary">
                                <div class="inner">
                                    <h3>{{parseInt(ttl_data_corpo) | toCurrency}}</h3>
                                    <small>Total Rp Invoice Paid</small>
                                    <!--p>Unpaid Bulan Ini</p-->
                                </div>
                                <div class="icon">
                                    <i class="fas fa-money-bill"></i>
                                </div>
                            </div>
                          </div>
                        </div>
                        <v-row class="mb-1">
                          <v-col :md="4">
                            <v-select
                              v-model="filter_corp"
                              :items="filter_plg"
                              item-text="text"
                              item-value="id"
                              label="Pilih Filter"
                              persistent-hint
                              return-object
                              single-line
                            ></v-select>
                          </v-col>
                          <v-col :md="4" :offset-md="4">
                            <v-text-field
                              v-model="cari_dt_plg_corp"
                              append-icon="mdi-magnify"
                              label="Pencarian"
                              single-line
                              hide-details
                            ></v-text-field>
                          </v-col>
                        </v-row>
                       
                        <v-data-table
                          @update:group-desc="tableGrouping"
                          :headers="headers_corp"
                          :footer-props="{ itemsPerPageOptions: [10,25,50,100,-1]}"
                          :items="datas_corp"
                          :items-per-page="25"
                          item-key="id"
                          sort-by="no"
                          class="elevation-1 "
                          show-group-by
                          :search="cari_dt_plg_corp">
                          <template v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
                            <td :colspan="headers.length-1">
                              <v-btn @click="toggle" x-small icon :ref="group">
                                  <v-icon v-if="isOpen">mdi-minus</v-icon>
                                  <v-icon v-else>mdi-plus</v-icon>
                              </v-btn>
                              <span class="mx-3"> Nama Pelanggan : <span class="font-weight-bold"> {{ group }}</span></span>
                              <!--a href="#" @click="editModal(item,'pelanggan')" title="Edit Data Pelanggan">
                                <i class="fa fa-user-edit text-blue"></i>
                              </a-->
                            </td>
                            <td>
                              <v-btn @click="remove" x-small icon class="">
                                  <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </td>
                          </template>
                          <!--template v-slot:item.checkbox="{ item }">
                            <v-container
                              class="px-0"
                              fluid
                            >
                              <v-checkbox
                              ></v-checkbox>
                            </v-container>
                          </template-->
                          <template v-slot:item.no="{ item }">
                            {{ item.no | zerofill }}
                          </template>
                          <template v-slot:item.total_kontrak="{ item }">
                            {{ item.total_kontrak | toCurrency }}
                          </template>
                          <template v-slot:item.total_bayar="{ item }">
                            {{ item.total_bayar | toCurrency }}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <!--a href="#" v-if="!table_group_state" class="mr-1" @click="editModal(item,'pelanggan')" title="Edit Data Pelanggan">
                              <i class="fa fa-user-edit text-blue"></i>
                            </a-->
                            <div class="tanpawrap">
                              <a href="#" class="mr-1" @click="printInvoice(item)" title="Lihat Invoice">
                                <i class="fa fa-file"></i>
                              </a>
                              /
                              <a href="#" class="ml-1" @click="bukaModal(item)" title="Edit Data">
                                <i class="fa fa-edit"></i>
                              </a>
                            </div>
                            <!--a href="#" class="ml-1" @click="false">
                              <i class="fas fa-trash text-red"></i>
                            </a-->
                            <!--a href="#" @click="deleteProduct(item.id)">
                              <i class="fas fa-trash text-red"></i>
                            </a-->
                            
                          </template>
                          <template v-slot:no-data>
                            <h4>Data Tidak Ditemukan</h4>
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                  </div>
                </v-content>
              </v-app>
              <!-- /.card-body -->
        
              <div class="card-footer">
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>
    </div>
          <div class="modal fade " id="modalEdit" tabindex="-1" role="dialog" aria-labelledby="modalEdit" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Edit Data Invoice</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="updateInvoice()" enctype="multipart/form-data" id="formnya">
                    <div class="modal-body">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="card card-outline card-primary">
                              <div class="card-header">
                                <h3 class="card-title" style="margin:0px">Data Pelanggan</h3>
                              </div>
                              <!-- /.card-header -->
                              <div class="card-body">
                                <input type="hidden" v-model="form.invoice.id" name="invoice.id" >
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="form-group">
                                        <label >Username </label>
                                        <input type="text" v-model="form.invoice.username" name="invoice.username"
                                            class="form-control" :class="{ 'is-invalid': adaeror['invoice.username'] }"  :readonly="true">
                                        <small  v-if="adaeror['invoice.username']" class="text-danger">
                                          {{adaeror["invoice.username"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="form-group">
                                        <label >Nama </label>
                                        <input type="text" v-model="form.invoice.nama" name="invoice.nama"
                                            class="form-control" :class="{ 'is-invalid': adaeror['invoice.nama'] }"  :readonly="true">
                                        <small  v-if="adaeror['invoice.nama']" class="text-danger">
                                          {{adaeror["invoice.nama"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="form-group">
                                        <label >Nama Tempat Instalasi </label>
                                        <input type="text" v-model="form.invoice.nama_tempat" name="invoice.nama_tempat"
                                            class="form-control" :class="{ 'is-invalid': adaeror['invoice.nama_tempat'] }"  :readonly="true">
                                        <small  v-if="adaeror['invoice.nama_tempat']" class="text-danger">
                                          {{adaeror["invoice.nama_tempat"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="form-group">
                                        <label >Paket </label>
                                        <input type="text" v-model="form.invoice.paket" name="invoice.paket"
                                            class="form-control" :class="{ 'is-invalid': adaeror['invoice.paket'] }"  :readonly="true">
                                        <small  v-if="adaeror['invoice.paket']" class="text-danger">
                                          {{adaeror["invoice.paket"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                </div>
                                
                                <hr style="border:1px solid;"/>
                                <h5>Data Billing</h5>
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >Harga Paket </label>
                                        <input type="text" v-model="form.invoice.harga_paket" name="invoice.harga_paket"
                                            class="form-control" :class="{ 'is-invalid': adaeror['invoice.harga_paket'] }" :readonly="true">
                                        <small  v-if="adaeror['invoice.harga_paket']" class="text-danger">
                                          {{adaeror["invoice.harga_paket"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >PPN  (Print? <input type="checkbox" v-model="form.invoice.print_pajak" name="print_pajak">) </label>
                                        <input type="text" v-model="form.invoice.ppn" name="invoice.ppn"
                                            class="form-control" :class="{ 'is-invalid': adaeror['invoice.ppn'] }"  :readonly="true">
                                         <small  v-if="adaeror['invoice.ppn']" class="text-danger">
                                          {{adaeror["invoice.ppn"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >Diskon Pengguna </label>
                                        <input type="text" v-model="form.invoice.diskon" name="invoice.diskon"
                                            class="form-control" :class="{ 'is-invalid': adaeror['invoice.diskon'] }"  :readonly="true">
                                         <small  v-if="adaeror['invoice.diskon']" class="text-danger">
                                          {{adaeror["invoice.diskon"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                </div>

                                <div class="row" v-show="tipe_pelanggan_edit == '2'">
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <label>Tanggal Terbit Invoice</label>
                                      <v-menu
                                          v-model="menu"
                                          :close-on-content-click="false"
                                          :nudge-right="40"
                                          transition="scale-transition"
                                          offset-y
                                          min-width="auto"
                                        >
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field style="margin-top:0px;padding-top:0px"
                                            v-model="form.invoice.tanggal"
                                            label=""
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="form.invoice.tanggal"
                                          @input="menu = false"
                                        ></v-date-picker>
                                      </v-menu>
                                      
                                      <!--input v-model="form.inet.billing_akhir" type="text" name="inet.billing_akhir"
                                          class="form-control" :class="{ 'is-invalid': form.errors.has('inet.billing_akhir') }" -->
                                      <small  v-if="adaeror['invoice.tanggal']" class="text-danger">
                                        {{adaeror["invoice.tanggal"].join(', ') }}
                                      </small>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <label>Tanggal Batas Bayar</label>
                                      <v-menu
                                          v-model="menu2"
                                          :close-on-content-click="false"
                                          :nudge-right="40"
                                          transition="scale-transition"
                                          offset-y
                                          min-width="auto"
                                        >
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field style="margin-top:0px;padding-top:0px"
                                            v-model="form.invoice.tanggal_batas_bayar"
                                            label=""
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="form.invoice.tanggal_batas_bayar"
                                          @input="menu2 = false"
                                        ></v-date-picker>
                                      </v-menu>
                                      
                                      <!--input v-model="form.inet.billing_akhir" type="text" name="inet.billing_akhir"
                                          class="form-control" :class="{ 'is-invalid': form.errors.has('inet.billing_akhir') }" -->
                                      <small  v-if="adaeror['invoice.tanggal_batas_bayar']" class="text-danger">
                                        {{adaeror["invoice.tanggal_batas_bayar"].join(', ') }}
                                      </small> 
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >Cashback</label>
                                        <input type="number" @keydown="preventArrow($event)" v-model="form.invoice.kickback" name="kickback" class="form-control" :class="{ 'is-invalid': adaeror['kickback'] }" :readonly="true">
                                         <small  v-if="adaeror['kickback']" class="text-danger">
                                          {{adaeror["kickback"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <!--div class="col-md-4">
                                    <div class="form-group">
                                        <label >Tagihan (Rp.)</label>
                                        <input type="number" v-model="form.invoice.total" name="total" class="form-control" :class="{ 'is-invalid': adaeror['total'] }" :readonly="true">
                                         <small  v-if="adaeror['total']" class="text-danger">
                                          {{adaeror["total"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div-->
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >PPN KELUARAN (Rp.)</label>
                                        <input type="number" @keydown="preventArrow($event)" v-model="form.invoice.ppn_keluaran" name="ppn_keluaran" class="form-control" :class="{ 'is-invalid': adaeror['total_potongan'] }" :readonly="true">
                                         <small  v-if="adaeror['total_potongan']" class="text-danger">
                                          {{adaeror['total_potongan'].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >PPH 23 (Rp.)</label>
                                        <input type="number" @keydown="preventArrow($event)" v-model="form.invoice.pph23" name="pph23" class="form-control" :class="{ 'is-invalid': adaeror['total_potongan'] }" :readonly="true">
                                         <small  v-if="adaeror['total_potongan']" class="text-danger">
                                          {{adaeror['total_potongan'].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >Zakat (Rp.)</label>
                                        <input type="number" v-model="form.invoice.zakat" name="zakat" class="form-control" :class="{ 'is-invalid': adaeror['total_potongan'] }" :readonly="true" >
                                         <small  v-if="adaeror['total_potongan']" class="text-danger">
                                          {{adaeror["total_potongan"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >Tagihan Pemakaian</label>
                                        <input type="text" v-model="form.invoice.tagihan" name="invoice.tagihan"
                                            class="form-control" :class="{ 'is-invalid': adaeror['invoice.tagihan'] }"  :readonly="true">
                                         <small  v-if="adaeror['invoice.tagihan']" class="text-danger">
                                          {{adaeror["invoice.tagihan"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >Total Bayar</label>
                                        <!--input type="number" @keydown="preventArrow($event)" v-model="form.invoice.total_bayar"  name="invoice.total_bayar" class="form-control" :class="{ 'is-invalid': adaeror['invoice.total_bayar'] }"  :readonly="tipe_pelanggan_edit != '2'"-->
                                        <input type="number" @keydown="preventArrow($event)" v-model="form.invoice.total_bayar"  name="invoice.total_bayar" class="form-control" :class="{ 'is-invalid': adaeror['invoice.total_bayar'] }"  :readonly="true">
                                         <small  v-if="adaeror['invoice.total_bayar']" class="text-danger">
                                          {{adaeror["invoice.total_bayar"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >Status </label>
                                        <select class="form-control is-warning" v-model="form.invoice.status_bayar" name="invoice.status_bayar">
                                          <!-- inline object literal -->
                                          <option :key="2" :value="0">Unpaid</option>
                                          <option :key="1" :value="1" selected>Paid</option>
                                        </select>
                                         <small  v-if="adaeror['invoice.status_bayar']" class="text-danger">
                                          {{adaeror["invoice.status_bayar"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                </div>
                                <!--div class="row" v-show="tipe_pelanggan_edit == '2' && this.form.invoice.total_bayar != this.form.invoice.total">
                                  <div class="col-md-12">
                                    <h5 style="text-align:center">Alasan Jumlah Bayar Tidak Sama Dengan Tagihan</h5>
                                  </div>
                                  
                                </div>
                                <div class="row" v-show="tipe_pelanggan_edit == '2' && this.form.invoice.total_bayar != this.form.invoice.total">
                                  
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >Downtime (Jam)</label>
                                        <input type="number" @keydown="preventArrow($event)" v-model="form.invoice.downtime" name="downtime" class="form-control" :class="{ 'is-invalid': adaeror['downtime'] }" >
                                         <small  v-if="adaeror['downtime']" class="text-danger">
                                          {{adaeror["downtime"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                        <label >Potongan Restitusi (Rp.)</label>
                                        <input type="number" @keydown="preventArrow($event)" v-model="form.invoice.downtime_rp" name="downtime_rp" class="form-control" :class="{ 'is-invalid': adaeror['total_potongan'] }" >
                                         <small  v-if="adaeror['total_potongan']" class="text-danger">
                                          {{adaeror['total_potongan'].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                </div>
                                <div class="row" v-show="tipe_pelanggan_edit == '2' && this.form.invoice.total_bayar != this.form.invoice.total">
                                  <div class="col-md-12">
                                    <div class="form-group">
                                        <label >Keterangan Lain</label>
                                        <textarea v-model="form.invoice.keterangan" style="resize:none;" rows="3" name="keterangan" class="form-control" :class="{ 'is-invalid': adaeror['keterangan'] }" ></textarea>
                                         <small  v-if="adaeror['keterangan']" class="text-danger">
                                          {{adaeror["keterangan"].join(', ') }}
                                        </small> 
                                    </div>
                                  </div>
                                </div-->
                              </div>
                              <!-- /.card-body -->
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
          </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                dateMax: new Date().toISOString().substr(0, 7),
                tanggal_query: new Date().toISOString().substr(0, 7),
                tanggal_tampil: '',
                filter_corp: "0",
                filter_pppoe: "0",
                filter_plg: [
                  { text: 'Semua', id: '0' },
                  { text: 'Harga Full', id: '1' },
                  { text: 'Harga Prorate', id: '2' },
                ],
                jlh_data_pppoe: '0',
                ttl_data_pppoe: '0',
                jlh_data_corpo: '0',
                ttl_data_corpo: '0',
                jlh_invoice: '0',
                ttl_invoice: '0',
                cari_dt_plg_corp: '',
                cari_dt_plg: '',
                checkbox: false,
                datas_corp : [],
                datas : [],
                form: new Form({invoice : {
                    id: '',
                    username: '',
                    nama: '',
                    nama_tempat: '',
                    paket: '',
                    harga_paket: '',
                    diskon: '',
                    ppn: '',
                    tagihan: '',
                    tanggal: '',
                    tanggal_batas_bayar: '',
                    total_bayar: '0',
                    total: '0',
                    status_bayar: '0',
                    print_pajak: '0',
                    print_diskon: '0',
                    kickback: '0',
                    ppn_keluaran: '0',
                    pph23: '0',
                    zakat: '0',
                    downtime: '0',
                    downtime_rp: '0',
                    keterangan: '',
                    kantor_id: '',
                  }
                }),
                modaltgl: false,
                menu2: false,
                menu: false,
                tipe_pelanggan_edit : '0',
                adaeror : [],
            }
        },
        computed: {
          headers () {
            return [
              // { text: '#', align: 'start', value: 'checkbox', sortable: false, groupable: false, },
              { text: 'No Inv', value: 'id', groupable: false, },
              //{ text: 'Username', value: 'pelanggan_internet.username', sortable: false, groupable: false, },
              //{ text: 'Nama Pelanggan', value: 'pelanggan_internet.pelanggan.nama', groupable: false, },
              { text: 'Tempat Instalasi', value: 'pelanggan_internet.nama', groupable: false, },
              //{ text: 'Paket', value: 'pelanggan_internet.paket.value', groupable: false, },
              //{ text: 'Tanggal Terbit', value: 'tanggal', groupable: false, },
              //{ text: 'Jatuh Tempo', value: 'tanggal_batas_bayar', groupable: false, },
              { text: 'Tipe Invoice', value: 'tipe_invoice_val', groupable: false, sortable: false, align:" d-none", filter: value => 
                {
                  if(this.filter_pppoe.id == 1){
                    return value === "Penuh";
                  }else if(this.filter_pppoe.id == 2){
                    return value === "Prorate";
                  }else{
                    return true;
                  }
                },
              },
              { text: 'Rp Kontrak', value: 'total_kontrak', groupable: false,},
              { text: 'Rp BAYAR', value: 'total_bayar', groupable: false,},
              { text: 'Tanggal Bayar', value: 'tanggal_bayar', groupable: false,},
              { text: 'Aksi', value: 'actions' , sortable: false, groupable: false,},
            ]
          },
          headers_corp () {
            return [
              // { text: '#', align: 'start', value: 'checkbox', sortable: false, groupable: false, },
              { text: 'No Inv', value: 'id', groupable: false, },
              //{ text: 'Username', value: 'pelanggan_internet.username', sortable: false, groupable: false, },
              //{ text: 'Nama Pelanggan', value: 'pelanggan_internet.pelanggan.nama', groupable: false, },
              { text: 'Tempat Instalasi', value: 'pelanggan_internet.nama', groupable: false, },
              //{ text: 'Paket', value: 'pelanggan_internet.paket.value', groupable: false, },
              //{ text: 'Tanggal Terbit', value: 'tanggal', groupable: false, },
              //{ text: 'Jatuh Tempo', value: 'tanggal_batas_bayar', groupable: false, },
              { text: 'Tipe Invoice', value: 'tipe_invoice_val', groupable: false, sortable: false, align:" d-none", filter: value => 
                {
                  if(this.filter_corp.id == 1){
                    return value === "Penuh";
                  }else if(this.filter_corp.id == 2){
                    return value === "Prorate";
                  }else{
                    return true;
                  }
                },
              },
              { text: 'Rp Kontrak', value: 'total_kontrak', groupable: false,},
              { text: 'Rp BAYAR', value: 'total_bayar', groupable: false,},
              { text: 'Tanggal Bayar', value: 'tanggal_bayar', groupable: false,},
              { text: 'Aksi', value: 'actions' , sortable: false, groupable: false,},
            ]
          },
        },
        methods: {
          ubahTanggalTampil(e) {
            e.dialog.save(this.tanggal_query);
            this.loadUnpaid();       
           // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
          },
          downloadFile(response, filename) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], {type: 'application/pdf'});

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download = filename + '.pdf'
            document.body.appendChild(link);
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
            }, 100)
          },
          printInvoice(item){
            this.$Progress.start();
            let namaFileDownload = "Invoice " + item.pelanggan_internet.nama + " " + item.bulan_pemakaian;
            axios.get('api/invoice/printpdf?id_invoice='+item.id, {responseType: 'blob'}).then(response => {
              this.downloadFile(response, namaFileDownload);
              this.$Progress.finish();
            }, response => {
                Toast.fire({
                    icon: 'error',
                    title: data.data.data ? data.data.data : "Error!. Download Invoice Gagal."
                });
                this.$Progress.fail();
            });
          },
          preventArrow(e) {
            if (e.which === 38 || e.which === 40) {
              e.preventDefault();
            }
            if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57)
            {
                e.preventDefault();
            }
           // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
          },
          updateInvoice(){
            this.$Progress.start();
            Swal.fire({
              title: 'Are you sure?',
              text: "Apakah Anda Yakin Untuk Mengupdate Data Invoice pelanggan?",
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Yes!'
            }).then((result) => {
              if (result.value) {
                let editFormData = new FormData();
                let dataUpdate = {};
                dataUpdate['id'] = this.form.invoice.id;
                dataUpdate['tanggal'] = this.form.invoice.tanggal;
                dataUpdate['tanggal_batas_bayar'] = this.form.invoice.tanggal_batas_bayar;
                dataUpdate['total_bayar'] = this.form.invoice.total_bayar;
                dataUpdate['status_bayar'] = this.form.invoice.status_bayar;
                dataUpdate['print_pajak'] = this.form.invoice.print_pajak;
                dataUpdate['print_diskon'] = this.form.invoice.print_diskon;
                dataUpdate['kickback'] = this.form.invoice.kickback;
                dataUpdate['total'] = this.form.invoice.total;
                dataUpdate['zakat'] = this.form.invoice.zakat;
                dataUpdate['pph23'] = this.form.invoice.pph23;
                dataUpdate['ppn_keluaran'] = this.form.invoice.ppn_keluaran;
                dataUpdate['downtime'] = this.form.invoice.downtime;
                dataUpdate['downtime_rp'] = this.form.invoice.downtime_rp;
                dataUpdate['keterangan'] = this.form.invoice.keterangan;
                dataUpdate['kantor_id'] = this.form.invoice.kantor_id;
                
                editFormData.append('datanya', JSON.stringify(dataUpdate));
                axios.post('api/invoice/edit_invoice_paid', editFormData).then((data) => {
                  if(data.data.success){

                      Toast.fire({
                          icon: 'success',
                          title: data.data.message
                      });
                      this.$Progress.finish();
                      this.loadUnpaid();
                      $('#modalEdit').modal('hide');
                  } else {
                      Toast.fire({
                          icon: 'error',
                          title: data.data.data ? data.data.data : "Error!. Try again later."
                      });

                      this.$Progress.fail();
                  }
                })
                .catch(e => {
                    Toast.fire({
                        icon: 'error',
                        title: data.data.data ? data.data.data : "Error!."
                    });
                    //console.log( e.response.data.errors);

                    this.$Progress.fail();
                });
              }
            })
          },
          bukaModal(item){
            this.adaeror = [];
            this.form.reset();
            this.tipe_pelanggan_edit = item.pelanggan_internet.tipe_langganan;
            this.form.invoice.id = item.id;
            this.form.invoice.username = item.pelanggan_internet.username;
            this.form.invoice.nama = item.pelanggan_internet.pelanggan.nama;
            this.form.invoice.nama_tempat = item.pelanggan_internet.nama;
            this.form.invoice.paket = item.nama_paket;
            this.form.invoice.harga_paket = item.harga_paket;
            this.form.invoice.diskon = item.diskon;
            this.form.invoice.tanggal_batas_bayar = item.tanggal_batas_bayar;
            this.form.invoice.tanggal = item.tanggal;
            this.form.invoice.ppn = item.ppn;
            this.form.invoice.tagihan = this.getBulan(item.bulan_pemakaian);
            this.form.invoice.total_bayar = item.total_bayar;
            this.form.invoice.total = item.total;
            this.form.invoice.status_bayar = '1';
            this.form.invoice.print_pajak = item.print_pajak;
            this.form.invoice.print_diskon = item.print_diskon;
            this.form.invoice.kickback = item.kickback ? item.kickback : 0 ;
            this.form.invoice.pph23 = item.pph23 ? item.pph23 : 0;
            this.form.invoice.ppn_keluaran = item.ppn_keluaran ? item.ppn_keluaran : 0;
            this.form.invoice.zakat = item.zakat ? item.zakat : 0;
            this.form.invoice.downtime = item.downtime ? item.downtime : 0;
            this.form.invoice.downtime_rp = item.downtime_rp ? item.downtime_rp : 0;
            this.form.invoice.keterangan = item.keterangan;
            this.form.invoice.kantor_id = item.pelanggan_internet.kantor_id;
            $('#modalEdit').modal('show');
          },
          tableGrouping(e) {
            if(e.length){
              this.table_group_state = true;
            }else{
              this.table_group_state = false;
            }
          },
          loadUnpaid(){
            let tahunpaid = this.tanggal_query.substr(0, 4);
            let bulanpaid = this.tanggal_query.substr(-2, 2);
            if(this.$gate.isAllowed("is_invoice")){
              
              if(this.$gate.dataType('1')){
                axios.get("api/invoice/list_paid?tipe=1&tahunpaid="+tahunpaid+"&bulanpaid="+bulanpaid).then(({ data }) => (this.datas = data.data));
                axios.get("api/invoice/list_paid_count?tipe=1&tahunpaid="+tahunpaid+"&bulanpaid="+bulanpaid).then(({ data }) => {
                  this.jlh_data_pppoe = parseInt(data.data[0].jumlah ? data.data[0].jumlah : 0);
                  this.ttl_data_pppoe = parseInt(data.data[0].total ? data.data[0].total : 0);
                });
              }
              if(this.$gate.dataType('2')){
                axios.get("api/invoice/list_paid?tipe=2&tahunpaid="+tahunpaid+"&bulanpaid="+bulanpaid).then(({ data }) => (this.datas_corp = data.data));
                axios.get("api/invoice/list_paid_count?tipe=2&tahunpaid="+tahunpaid+"&bulanpaid="+bulanpaid).then(({ data }) => {
                  this.jlh_data_corpo = parseInt(data.data[0].jumlah ? data.data[0].jumlah : 0);
                  this.ttl_data_corpo = parseInt(data.data[0].total ? data.data[0].total : 0 );
                });
              }
            }
            this.tanggal_tampil = this.getBulan(this.tanggal_query);
          },
          getBulan(tanggal){
            var tgltemp = new Date(tanggal);
            var tahun = tgltemp.getFullYear();
            var bulan = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
            
            return (bulan[tgltemp.getMonth()] + " " + tahun);
          },
        },
        mounted() {
            
        },
        created() {
            this.$Progress.start();

            this.loadUnpaid();

            this.$Progress.finish();
        },
    }
</script>
<style scoped>

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.tanpawrap {
  white-space: nowrap;
}
</style>